import React from 'react';
import { Wrapper, Header } from '../forms/Form';
import { Content } from '../forms/ConfirmationDialogue';
import { LatestActivitiesSection } from '../content_management/item_page/latestActivitiesSection';
import { generateRandomString } from '../../supplementary_components/supplementaryMethods';
import { popupComponents$ } from '../../supplementary_components/store';
import styles from './activitiesPopup.module.scss';

export const ENTITY_ACTIVITIES_POPUP_KIND = 'entityActivities';

export function openActivitiesPopup({
    targetType,
    objectId,
    titleLabel = '',
    popupKind = ENTITY_ACTIVITIES_POPUP_KIND,
    customMaxWidth = '42rem',
}) {
    const withoutExisting = popupComponents$.getValue().filter(
        (popup) => popup.popupData?.popupKind !== popupKind,
    );
    popupComponents$.next([
        ...withoutExisting,
        {
            content: ActivitiesPopup,
            popupData: {
                popupKind,
                targetType,
                objectId,
                titleLabel,
            },
            EZCloseAllowed: true,
            customMaxWidth,
        },
    ]);
}

export const ActivitiesPopup = ({ popupData }) => {
    const titleLabel = popupData?.titleLabel ?? '';
    return (
        <Wrapper onClick={(e) => e.stopPropagation()}>
            <Header>
                <span>Latest Activities — {titleLabel}</span>
            </Header>
            <Content>
                <div className={styles.activitiesPopupBody}>
                    <LatestActivitiesSection
                        type={popupData.targetType}
                        objectId={popupData.objectId}
                        refreshKey={generateRandomString(4)}
                        emptyMessage="No Previous Activities"
                    />
                </div>
            </Content>
        </Wrapper>
    );
};
